import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { Distance, Percentage, Pixel } from "../units/Units"
import type { BlobMap } from "./BlobMap"
import type { ColorMap } from "./ColorMap"
import type { ScaleMap } from "./ScaleMap"

export type PlottingContext = Partial<{
  readonly color_map: ColorMap
  readonly file_map: BlobMap
  readonly scale_map: ScaleMap
  readonly unit_to_px: number
  readonly page_bleed: Distance
  readonly scale_bleed: Distance
  readonly stroke_width: Distance
  readonly font_size: Pixel
  readonly font_family: string
  readonly font_height_adjustment: Percentage
  readonly image_resolution: Pixel
  readonly horizontal_align: HorizontalAlign
  readonly vertical_align: VerticalAlign
}>
